<div class="text-end"></div>

<div class="row">
    <div class="col-sm-4">
      <h3 class="sub-title">Task Templates</h3></div>
    <div class="col-sm-8 text-end mt-2 mb-2">
        <a [routerLink]="['/admin/study/concept/new']" class="btn btn-primary"> New Concept </a>
    </div>
  </div>
<div class="table-responsive" *ngIf="conceptList.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Id</th>
    <th>Name</th>
    <th>Title</th>

   </tr>
    </thead>

    <tbody>

    <tr *ngFor="let conceptItem of conceptList;">
        <td>
            <a [routerLink]="['/admin/study/concept/show',conceptItem.server_concept_id]">
            {{conceptItem.server_concept_id}}
            </a>
        </td>
        <td>{{conceptItem.name}}</td>
        <td>{{conceptItem.title}}</td>


    </tr>

    </tbody>

</table>
</div>
<div class="text-center mt-2">
    <a [routerLink]="['/home/admin/show']" class="btn btn-primary"> <i class="fa fa-home"></i> Home</a>
</div>
